import React,{useEffect, useRef, useState} from 'react';
import { Panel } from 'primereact/panel';
import  ToLogin  from '../../../components/misc/Redirect/ToLogin';
import Disponibles from './Disponibles';
import  Result  from '../../../components/misc/Message/Result';
import { PagoExpress } from '../../terminosCondiciones/PagoExpress';
import  ToHomeFromAdelantar  from '../../../components/misc/Redirect/ToHomeFromAdelantar';
import { Dialog } from 'primereact/dialog';
import { AceptarTerminos } from '../../terminosCondiciones/AceptarTerminos';
import { useReembolsoExpressContext } from '../context/reembolsoExpress.context';
import { getEmpresarial } from '../services/empresarial.service';
import { obtenerTyC } from '../services/terminosyCondiciones.service';
import { getCallBack_parametros } from '../services/reembolso.service';
import { IOpcion } from '../../../interfaces/OpcionReembolso';
import Adelantar from './Adelantar';
import { ITyCRequest } from '../../../interfaces/ITyCRequest';
import { aceptarTyC2 } from '../../shared/services/terminosycondiciones.service';
import { homeSetUsuario } from '../services/home.service';
import { getVerificar } from '../../shared/services/verificarCarga.service';
import { apiSetComercios } from '../../shared/services/comercio.service';
import { useGlobalContext } from '../../shared/context/global.context';

const Reembolso = React.memo(() => {
    const {setUsers,setUserSelected,userLogged} = useGlobalContext()
    const {state, setState,setIsEmpresarial,setRequestedCard,adelanto,setAdelanto} = useReembolsoExpressContext()
    const [LoadingDataAdelantar,setLoadingDataAdelantar] = useState(true)

    const sessionSetUsuario = async (usuarioComercio:string) => {
        const {data,status} = await homeSetUsuario({ value: usuarioComercio })
        if(status === 200){
            //resetDataCuit({cuits:[],fetchCuit:false})
        }
    }

    useEffect(()=>{
        (async () => {
            if(!userLogged) return
            const verificarCarga2 = await getVerificar()
            if(verificarCarga2.status === 200){
                if(Object.keys(verificarCarga2).length > 0){

                    const {data,status} = await apiSetComercios({ value: verificarCarga2.data.comerciosString })

                    if(status === 200){
                        if(data.usuarios.length > 1 && !userLogged.activeDirectory ){
                            let userSelected = data.usuarios.filter((item:any) => item.login === userLogged.login)
                            
                            await sessionSetUsuario(userLogged.login)

                            if (userSelected.length > 0) {
                                await loadParametros()
                                setUsers(userSelected)
                                setUserSelected(userSelected[0].login);
                                
                            }else{
                                //usuario no lanet sin tarjeta emp
                                //await sessionSetUsuario("")
                                await loadParametros()
                                setUsers(data.usuarios)
                                setUserSelected("")
                            }
                        }else{
                            await sessionSetUsuario(userLogged.login)
                            await loadParametros()
                            setUsers(data.usuarios)
                            if (data.usuarios.length > 0) {
                                //setUserSelected(data.usuarios[0].login);
                                setUserSelected("")
                            }
                        }
                    }

                }
            }
            setLoadingDataAdelantar(false)
        }
        )();
    }, [userLogged])

    const processMetodoDePago = (online: any, data: any, transferencia: any) => {
        let opcionOnLine: IOpcion = {
            tna: online[0].tna,
            gastoAdmin: online[0].gastosAdministrativos,
            costoAdelanto: 0,
            adelanto: 0,
            IVA: 0,
            plazo: online[0].diasPago,
            plazoTexto: (online[0].diasPago === 1 ? "1 Día" : online[0].diasPago + " Días "),
            medio: true,
            cupo: data.respuestaCupo.cupoEmpresarial,
            intereses: 0,
            montoAcreditar: 0,
            permiteExpress: online[0].permiteExpress,
            adelantoMaximo: 0,
            percepciones: 0
        };
        let opcionTransf: IOpcion = {
            tna: transferencia[0].tna,
            gastoAdmin: transferencia[0].gastosAdministrativos,
            costoAdelanto: 0,
            adelanto: 0,
            IVA: 0,
            plazo: transferencia[0].diasPago,
            plazoTexto: (transferencia[0].diasPago == 1 ? "1 Día" : transferencia[0].diasPago + " Días "),
            medio: false,
            cupo: data.respuestaCupo.cupoTransferencia,
            intereses: 0,
            montoAcreditar: 0,
            permiteExpress: transferencia[0].permiteExpress,
            adelantoMaximo: 0,
            percepciones: 0
        };
        return { opcionOnLine, opcionTransf };
    }  
    
    const loadParametros = async () => {
        const {data,status} = await getCallBack_parametros()
        let dataResponseReembolso = {}
        let dataEmpresarial = {}
        if(status === 200){
        if (data.hasOwnProperty('nologin')  && data.nologin != undefined && data.nologin.indexOf("http") > -1) {
            dataResponseReembolso = {redirectLogin: true, url: data.nologin };
        }
        else {
            let online = data.respuesta.metodosPago.filter((on: { metodoPagoId: number; }) => on.metodoPagoId === 15);
            let transferencia = data.respuesta.metodosPago.filter((tra: { metodoPagoId: number; }) => tra.metodoPagoId === 3);
            let { opcionOnLine, opcionTransf }: { opcionOnLine: IOpcion; opcionTransf: IOpcion; } = processMetodoDePago(online, data, transferencia);
            let opcionDefault: Array<IOpcion> = [];
            opcionDefault.push(opcionOnLine);
            opcionDefault.push(opcionTransf);

            dataResponseReembolso ={ opcion: opcionDefault, metodosPago: data.respuesta.metodosPago, habilitadoLanet: data.habilitar }

        }

        const result = await getEmpresarial();
        let responseGetEmp = result.data
        if(result.status === 200){
            if (typeof responseGetEmp === "object" && responseGetEmp.nologin != undefined && responseGetEmp.nologin.indexOf("http") > -1) {
                setState({...state, redirectLogin: true, url: responseGetEmp.nologin})
            }
            else {
                if (responseGetEmp == 0){
                    setIsEmpresarial(false)
                }
                else if (responseGetEmp == 1){
                    setIsEmpresarial(false)
                    setRequestedCard(true)
                }
                else if (responseGetEmp == 2){
                    setIsEmpresarial(true)
                }
                
            }
            let postData: ITyCRequest = {
                idTyC: 10,
            }
            
            const resultTyC = await obtenerTyC(postData)
            if(resultTyC.status === 200){
                if (resultTyC.data.nologin != undefined && resultTyC.data.nologin.indexOf("http") > -1) {
                    setState({...state, redirectLogin: true, url: resultTyC.data.nologin})
                }
                else 
                    setState({ ...state, tycVisible: !resultTyC.data.tyC, loadingTyC: false, ...dataEmpresarial, ...dataResponseReembolso });
            }
        }
    }
}

    const handleResult = () => {
        setAdelanto("")
    }
    const onAcceptar = async () => {
        let postData: ITyCRequest = {
            idTyC: 10,
        }
        let response = await aceptarTyC2(postData)
        if(response.status === 200){
            if (response.data.nologin != undefined && response.data.nologin.indexOf("http") > -1) {
                setState({...state, redirectLogin: true, url: response.data.nologin });
            }
            else if (response.data.success)
                setState({ ...state,tycVisible: false });
        }
    }

    const onCancelar = async () => {
        setState({...state,
            redirect: true
        });
    }

    const onHide = async () => {
        onCancelar();
    }
    
    const result = (
        <div>
            {(() => {
                switch (adelanto) {
                    case 'success':
                        return <Result
                            accept={handleResult}
                            title="Pago Express"
                            message="¡Adelanto realizado con Éxito!"
                            redirect={true}
                            url=""
                            type="success" />
                    case 'error':
                        return <Result
                            accept={handleResult}
                            title="Pago Express"
                            message="Hubo un problema, si el error persiste llame al administrador del sistema."
                            redirect={false}
                            url=""
                            type="error" />
                }
            })()}
        </div>
    );
    
   

    const tyc = <PagoExpress />;
    if (state.redirectLogin) {
        return <ToLogin url={state.url} />
    }
    
    if (state.redirect) {
        return <ToHomeFromAdelantar tyc={true} />
    }
    
    if (state.tycVisible) {
        return (<Dialog header="Terminos y Condiciones" style={{ width: '60vw' }} visible={state.tycVisible} onHide={onHide} blockScroll>
            <AceptarTerminos componente={tyc} onAcceptar={onAcceptar} onCancelar={onCancelar} />
        </Dialog>)
    }

    if(LoadingDataAdelantar ){
        return (<div className="loading">
            <span className="spinner-border" role="status"></span>
            <p className="d-block mt-3">Cargando</p>
        </div>)
    }
    

    if (state.opcion != undefined && !state.loadingTyC && !LoadingDataAdelantar){
        return (
            <div>
                {result}
                <main className="layout-main dashboard">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 mt-4">
                            <Panel header="Adelantar Pagos">
                                <Adelantar/>
                            </Panel>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 mt-4">
                            <Panel header="Pagos Programados">
                                <Disponibles />
                            </Panel>
                        </div>
                    </div>
                </main>
            </div>
        )
        }else
        return (<div className="loading">
            <span className="spinner-border" role="status"></span>
            <p className="d-block mt-3">Cargando</p>
        </div>);
})

export default Reembolso





